import { Text, View } from '@react-pdf/renderer';
import ReportFlex from './ReportFlex';
import styles from './styles';
import { useTranslation } from 'react-i18next';

type Props = {
  header: string;
  children: React.ReactNode | React.ReactNode[];
  showSeparator: boolean;
};

function ReportDetail({ header, children, showSeparator }: Props) {
  const { t } = useTranslation();

  return (
    <ReportFlex column noWrap>
      <View style={styles.reportDetailHeader}>
        <Text>{t(header)}</Text>
      </View>
      <View style={styles.reportDetailContent}>{children}</View>
      {showSeparator && <View style={[styles.horizontalSeparator, { margin: 8 }]} />}
    </ReportFlex>
  );
}

export default ReportDetail;
